


































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import columns from "./transfer-order-columns";
import adminColumns from "./admin-transfer-order-columns";
class PageTransferOrderRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  srcWarehouseCode: string;
  dstWarehouseCode: string;
  fromDate: Date;
  toDate: Date;
}

@Component
export default class TransferOrder extends mixins(ListMixin, AbpBase) {
  namespace = "transferOrder";
  pagerequest: PageTransferOrderRequest = new PageTransferOrderRequest();
  creationTime: Date[] = [];
  warehouses = [];
  clients = [];
  get store() {
    return this.$store.state.transferOrder;
  }
  isClient() {
    return this.$store.state.session.client != null;
  }
  isTenant() {
    return this.$store.state.session.tenant != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        if (!this.isClient())
          this.pagerequest.clientCode = re.length === 0 ? "" : re[0].code;
        this.clients = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getAllListForSelect",
        data: { hasAllItem: true },
      })
      .then((re) => {
        this.warehouses = re;
        if (this.warehouses.length > 0) {
          if (this.isTenant())
            this.pagerequest.srcWarehouseCode = this.tenant.tenancyName;
          else this.pagerequest.srcWarehouseCode = this.warehouses[0].id;
          this.pagerequest.dstWarehouseCode = this.warehouses[0].id;
        }
      });
  }
  get list() {
    var re = this.$store.state.transferOrder.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function (item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }

    if (this.creationTime.length > 0) {
      this.pagerequest.fromDate = this.creationTime[0];
    }
    if (this.creationTime.length > 1) {
      this.pagerequest.toDate = this.creationTime[1];
    }
  }
  renderColumn() {
    if (this.isClient()) {
      return columns;
    }
    return adminColumns.concat(columns);
  }
  importTransferOrders() {
    this.$router.push({ path: "import-transferOrder" });
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 80,
    },
    ...this.renderColumn(),
    {
      title: Util.L("Action"),
      width: 100,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  async created() {
    await this.getClients();
    await this.getWarehouses();
    var defaultDate = new Date();
    this.creationTime = [defaultDate, defaultDate];
  }
}
